<template>
    <header class="header">
        <div class="navbar">
            <div class="flex-1 flex">
                <div class="navbar-item">
                    <fold />
                </div>
                <div class="navbar-item">
                    <refresh />
                </div>
                <div
                    class="flex items-center px-2"
                    v-if="!isMobile && settingStore.showCrumb"
                >
                    <breadcrumb />
                </div>
            </div>
            <div class="flex">
                <div class="navbar-item" v-if="!isMobile">
                    <full-screen />
                </div>
                <div class="navbar-item">
                    <user-drop-down />
                </div>
                <div class="navbar-item">
                    <setting />
                </div>
            </div>
        </div>
        <multiple-tabs v-if="settingStore.openMultipleTabs" />
    </header>
</template>

<script setup lang="ts">
import useAppStore from '@/stores/modules/app'
import Fold from './fold.vue'
import Refresh from './refresh.vue'
import Breadcrumb from './breadcrumb.vue'
import FullScreen from './full-screen.vue'
import UserDropDown from './user-drop-down.vue'
import Setting from '../setting/index.vue'
import MultipleTabs from './multiple-tabs.vue'

import useSettingStore from '@/stores/modules/setting'
import { ThemeEnum } from '@/enums/appEnums'

import defaultSetting from '@/config/setting'

const appStore = useAppStore()
const isMobile = computed(() => appStore.isMobile)
const settingStore = useSettingStore()
const sideTheme = computed(() => settingStore.sideTheme)

const isAark = computed(() => {
    return sideTheme.value == ThemeEnum.DARK
})

const navbarBgc = computed(() => {
    return isAark.value ? defaultSetting.sideDarkColor : 'var(--el-bg-color)'
})

const navbarHoverBgc = computed(() => {
    return isAark.value ? '#214885' : 'var(--el-color-primary-light-9)'
})

const iconColor = computed(() => {
    return isAark.value ? '#fff' : 'inherit'
})

const textColor = computed(() => {
    return isAark.value ? '#c4d1e6' : 'var(--el-text-color-regular)'
})
</script>

<style lang="scss">
.navbar {
    height: var(--navbar-height);
    @apply flex px-2 bg-body;
    background-color: v-bind('navbarBgc');
    .navbar-item {
        @apply h-full  flex justify-center items-center;
        color: v-bind('iconColor');
        &:hover {
            background-color: v-bind('navbarHoverBgc');
        }
    }
    .el-breadcrumb__inner {
        color: v-bind('textColor') !important;
    }
    .user-name,
    .more {
        color: v-bind('textColor') !important;
    }
}
</style>
